export default __webpack_public_path__ + "static/journey-d589b15fd16ef4d7d933c737e5407611.png";